import { isTestMode } from "src/config/env";

const isMockView = () =>
  Boolean(window.localStorage.getItem("use_mocks") || isTestMode());

export default isMockView;
